module.exports = __webpack_public_path__ + "static/media/claimsforce_icon.10c605bc.svg";